module.exports = __webpack_public_path__ + "img/202504_06.3073535b.jpg";